import { render, staticRenderFns } from "./wxBillDetail.vue?vue&type=template&id=7d3af0ae&"
import script from "./wxBillDetail.vue?vue&type=script&lang=js&"
export * from "./wxBillDetail.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports